export default __webpack_public_path__ + "file/Fiche-EN-Produit-Puroak-Block-24.asset.377c094e.pdf";